export default __webpack_public_path__ + "static/media/product-preview.55c4e25e.jpg";